<template>
  <div class="modal_download">

    <div class="modal_download__header">
      <h4 class="title">
        {{ translate('esim_profile.new_upload') }}
      </h4>
    </div>

    <div class="download__content">

      <div class="download__answer" v-if="answer.status">
        <div
          v-for="(message, key_message) in answer.messages"
          :key="key_message"
          class="message"
        >
          <div class="left">
            <span class="title">{{key_message}}:</span>
          </div>
          <div class="right">
            <span class="text" v-for="(text, key_text) in message" :key="key_text">
              {{ text }}
            </span>
          </div>

        </div>
      </div>

      <div class="download__button">
        <button
          type="submit"
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="send"
        >
          {{ confirm ? 'Eject' : 'Check'}}
        </button>

        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: "UploadToDevice",
  props: ['esim_id'],
  data () {
    return {
      confirm: false,
      answer:{
        status: false,
        messages: {}
      },
    }
  },
  mounted(){
    this.send()
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    send(){
      this.answer.status = false
      this.answer.messages = {}

      this.$http.simcard.resetDevice(this.esim_id, {confirm: this.confirm}, (response) => {
        if (!this.confirm) {
          this.confirm = true

          this.answer.status = true
          this.answer.messages = response.data
        }else{
          this.global_notify('info', this.translate('profile_saved'))
          // this.$store.dispatch('updateSimcardDevicesProfile', this.simcard.imsi)
          this.$emit("update")
          this.cancel()
        }

      },
      (bad_answer) => {
        this.answer.status = true
        this.answer.messages = bad_answer.data.error.message
        this.bad_answer_handler(bad_answer)
      })
    }
  }
}

</script>

<style lang='scss'>
  .modal_download{
    padding: 10px;
    &__header{
      text-align: center;
      .title{
        margin: 10px 0;
      }
    }
    .download{
      &__content{

      }
      &__answer{
        font-size: 12px;
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        .message{
          display: flex;
          .left{
            margin-right: 5px;
          }
          .right{
            .text{
              display: block;
            }
          }
          .title{
            font-weight: bold;
            text-transform: uppercase;
          }
        }
      }
      &__button{
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }

  }


</style>
